export default {
      id: "smile-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "img/icons.svg#smile",
      toString: function () {
        return this.url;
      }
    }